import React, { useState } from 'react';

import { AlineInput } from 'src/AlineInput';
import { ConfirmationDialog } from 'src/components';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },
  numberInput: {
    width: '100%',
  },
}));

interface RunCoreAiDialogProps {
  documentCount: number;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
}

export function RunCoreAiDialog({
  documentCount,
  onClose,
  onConfirm,
  open,
}: RunCoreAiDialogProps): JSX.Element {
  const { classes } = useStyles();
  const [confirmNumber, setConfirmNumber] = useState<string>('');
  const isValid = confirmNumber === documentCount.toString();

  const handleConfirm = () => {
    if (isValid) {
      onConfirm();
      onClose();
    }
  };

  const handleClose = () => {
    setConfirmNumber('');
    onClose();
  };

  return (
    <ConfirmationDialog
      message={`Are you sure you want to run core AI for the selected documents? This will consume AI tokens and cannot be undone.`}
      open={open}
      primaryDisabledReason={!isValid ? `Type ${documentCount} to confirm` : ''}
      primaryText="Run Core AI"
      title="Run Core AI for Documents"
      onClickPrimary={handleConfirm}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <AlineInput
          autoFocus
          className={classes.numberInput}
          placeholder={`Type ${documentCount} to run core AI for the selected documents...`}
          value={confirmNumber}
          onChange={e => setConfirmNumber(e.target.value)}
        />
      </div>
    </ConfirmationDialog>
  );
}
